module.exports = __webpack_public_path__ + "media/images/sp/specials/fair_event/event_raiten-6446bceff8023789bb29d9bc42db0a25.jpg";